var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("div", { staticClass: "d-flex align-center" }, [
            _c("h5", { staticClass: "rotate-text" }, [
              _vm._v("\n        Template\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "left-side" },
              [
                _c("v-skeleton-loader", {
                  staticClass: "skeleton-position",
                  attrs: {
                    width: "210px",
                    height: "20px",
                    type: "list-item, list-item "
                  }
                }),
                _vm._v(" "),
                _c("v-skeleton-loader", {
                  staticClass: "ml-5",
                  attrs: {
                    width: "585px",
                    height: "80px",
                    type:
                      "list-item, heading, heading, heading, list-item, list-item, list-item "
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14b8c83f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14b8c83f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Organisms/SkeletonLoader.vue
// module id = null
// module chunks = 